export const ACTIVE_CHAT_POSITION = "ACTIVE_CHAT_POSITION";
export const ACTIVE_CHAT_ID = "ACTIVE_CHAT_ID";
export const ADD_LOGGED_USER = "ADD_LOGGED_USER";
export const CHAT_USER = "CHAT_USER";
export const CREATE_GROUP = "CREATE_GROUP";
export const FULL_DIALOG = "FULL_DIALOG";
export const TEXT_MESSAGE = "TEXT_MESSAGE";
export const MUTED = "MUTED";
export const ONLINE_USERS = "ONLINE_USERS";
export const UPDATE_MESSAGES = "UPDATE_MESSAGES";
export const UPDATE_LAST_MESSAGES = "UPDATE_LAST_MESSAGES";
export const RELOAD_CHATS = "RELOAD_CHATS";
export const FILTER_CHATS = "FILTER_CHATS";